import { __awaiter, __decorate, __generator, __metadata, __spreadArrays } from "tslib";
import { action, computed, observable } from 'mobx';
var CheckAddressStore = (function () {
    function CheckAddressStore(rootStore) {
        this.rootStore = rootStore;
        this.manualAddress = {};
        this.selectedAddress = {};
        this.streetTypes = [];
        this.unitTypes = [];
        this.levelTypes = [];
        this.states = [];
        this.slAddresses = [];
        this.serviceClass = 0;
        this.serviceClassDescription = '';
        this.showConfirmation = false;
        this.showFail = false;
        this.notServiceable = false;
        this.nbnLocId = '';
        this.formattedAddress = '';
        this.isLineInUse = false;
        this.newDevelopmentsChargeApplies = false;
        this.newConnectionChargeApplies = false;
        this.contractCodes = [];
        this.qualificationResponse = {};
        this.addressesResponse = [];
        this.locIdSelected = '';
        this.sqAddressResponse = {};
        this.providerCode = '';
        this.loading = false;
        this.error = '';
        this.flipToFibreService = false;
        this.upgardeSelected = false;
    }
    Object.defineProperty(CheckAddressStore.prototype, "serviceAddress", {
        get: function () {
            return {
                hasStreetNo: false,
                latitude: this.manualAddress.latitude,
                levelNumber: this.manualAddress.levelNumber,
                levelType: this.manualAddress.levelType,
                longitude: this.manualAddress.longitude,
                postCode: this.manualAddress.postcode,
                state: this.manualAddress.state,
                street: this.manualAddress.streetName,
                streetNumber: this.manualAddress.streetNumber,
                streetType: this.manualAddress.streetType,
                suburb: this.manualAddress.suburb,
                unitNumber: this.manualAddress.unitNumber,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckAddressStore.prototype, "serviceAddress2", {
        get: function () {
            return {
                levelNumber: this.manualAddress.levelNumber,
                levelType: this.manualAddress.levelType,
                lotNumber: this.manualAddress.lotNumber,
                nbnLocId: this.nbnLocId,
                postCode: this.manualAddress.postcode,
                state: this.manualAddress.state,
                streetName: this.manualAddress.streetName,
                streetNumber: this.manualAddress.streetNumber,
                streetType: this.manualAddress.streetType,
                suburb: this.manualAddress.suburb,
                unitNumber: this.manualAddress.unitNumber,
                unitType: this.manualAddress.unitType,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckAddressStore.prototype, "slServiceAddress", {
        get: function () {
            return {
                sourceType: 'nbn',
                searchType: 'address',
                countryCode: 'AU',
                streetName: this.manualAddress.streetName,
                streetNumber: this.manualAddress.streetNumber,
                streetType: this.manualAddress.streetType,
                suburb: this.manualAddress.suburb,
                state: this.manualAddress.state,
                postCode: this.manualAddress.postcode,
                unitNumber: this.manualAddress.unitNumber,
            };
        },
        enumerable: true,
        configurable: true
    });
    CheckAddressStore.prototype.getAddressesResponse = function () {
        return this.addressesResponse;
    };
    CheckAddressStore.prototype.addAddressProviderDetails = function (locId, provideName) {
        this.locIdSelected = locId;
        this.providerSelected = provideName;
    };
    CheckAddressStore.prototype.addressesSearched = function (value) {
        this.addressesResponse = value;
    };
    CheckAddressStore.prototype.loadLevelTypes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.rootStore.api.V1.Lookup.Address.LevelTypes()];
                    case 1:
                        response = _a.sent();
                        this.levelTypes = response.levelTypes;
                        return [2];
                }
            });
        });
    };
    CheckAddressStore.prototype.loadStreetTypes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.rootStore.api.V1.Lookup.Address.StreetTypes()];
                    case 1:
                        response = _a.sent();
                        this.streetTypes = CheckAddressStore.sortStreetTypes(response.streetTypes);
                        return [2];
                }
            });
        });
    };
    CheckAddressStore.prototype.loadStates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.rootStore.api.V1.Lookup.Address.LocationStates()];
                    case 1:
                        response = _a.sent();
                        this.states = response.locationStates;
                        return [2];
                }
            });
        });
    };
    CheckAddressStore.prototype.loadUnitTypes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.rootStore.api.V1.Lookup.Address.UnitTypes()];
                    case 1:
                        response = _a.sent();
                        this.unitTypes = response.unitTypes.sort(CheckAddressStore.sortByNameAscending);
                        return [2];
                }
            });
        });
    };
    Object.defineProperty(CheckAddressStore.prototype, "formatAddress", {
        get: function () {
            var addrString = '';
            var address = this.manualAddress;
            if (address.unitNumber) {
                addrString = address.unitNumber + "/";
            }
            if (address.streetNumber) {
                addrString = "" + addrString + address.streetNumber;
            }
            addrString = addrString + " " + address.streetName + " " + address.streetType + ", " + address.suburb + " " + address.state + " " + address.postcode;
            return addrString;
        },
        enumerable: true,
        configurable: true
    });
    CheckAddressStore.prototype.manualAddressServiceQualification = function () {
        return __awaiter(this, void 0, void 0, function () {
            var addressSearched, param, response, data, formattedAddress, loc, name, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        addressSearched = this.formatAddress;
                        console.log(addressSearched);
                        this.loading = true;
                        this.error = '';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        param = new URLSearchParams({
                            fullText: addressSearched,
                            source: 'footprint',
                        });
                        return [4, fetch("https://lookup.anex.com.au/api/v1/address?" + param)];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) {
                            this.error = 'Something went wrong searching for your address!';
                        }
                        return [4, response.json()];
                    case 3:
                        data = _a.sent();
                        this.addressesSearched(data);
                        if (data.length > 1) {
                            console.log(data);
                            this.showConfirmation = true;
                            this.loading = false;
                        }
                        if (data.length == 1) {
                            formattedAddress = data[0].formattedAddress;
                            loc = data[0].providers[0].locationId;
                            name = data[0].providers[0].name;
                            this.addAddressProviderDetails(loc, name);
                            this.formattedAddress = formattedAddress;
                            this.serviceQualification();
                        }
                        if (data.length == 0) {
                            if (this.rootStore.config.wholesaleCustomerCode === 'BDF') {
                                this.showFail = false;
                                this.rootStore.appStore.gotoState(2);
                            }
                            else {
                                this.showFail = true;
                            }
                            this.loading = false;
                        }
                        return [3, 5];
                    case 4:
                        error_1 = _a.sent();
                        this.error =
                            'Something went wrong searching for your address! Please check your address details and try again.';
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    };
    CheckAddressStore.prototype.addressSearch = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var param, response, data, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        param = new URLSearchParams({
                            fullText: value,
                            source: 'footprint',
                        });
                        return [4, fetch("https://lookup.anex.com.au/api/v1/address?" + param)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            this.error = 'Something went wrong searching for your address!';
                        }
                        return [4, response.json()];
                    case 2:
                        data = _a.sent();
                        if (data.length === 0) {
                            this.error = 'Something went wrong searching for your address!';
                        }
                        else {
                            this.addressesSearched(data);
                        }
                        return [3, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.error =
                            'Something went wrong searching for your address! Please check your address details and try again.';
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    CheckAddressStore.prototype.qualifyByAddress = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var formattedAddress, loc, name;
            return __generator(this, function (_a) {
                formattedAddress = address.formattedAddress;
                loc = address.providers[0].locationId;
                name = address.providers[0].name;
                this.addAddressProviderDetails(loc, name);
                this.formattedAddress = formattedAddress;
                this.serviceQualification();
                return [2];
            });
        });
    };
    CheckAddressStore.prototype.serviceQualification = function () {
        return __awaiter(this, void 0, void 0, function () {
            var loc, params, response, data, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        this.error = '';
                        loc = this.locIdSelected.substring(0, 3);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        params = new URLSearchParams();
                        params.append(this.providerSelected.toLowerCase(), this
                            .locIdSelected);
                        return [4, fetch("https://lookup.anex.com.au/api/v1/service-qualification?" + params)];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) {
                            this.showFail = true;
                            this.loading = false;
                        }
                        return [4, response.json()];
                    case 3:
                        data = _a.sent();
                        this.sqAddressResponse = data || [];
                        if (data.sqSummary.nbn != null) {
                            this.mapNbnSqResponseData(data.sqSummary);
                        }
                        else if (data.sqSummary.uniti != null) {
                            if (data.sqSummary.uniti.locationDetails != null) {
                                this.mapUnitiSqResponseData(data.sqSummary);
                            }
                            else {
                                this.showFail = true;
                            }
                        }
                        if (data == null) {
                            if (this.rootStore.config.wholesaleCustomerCode === 'BDF') {
                                this.showFail = false;
                                this.rootStore.appStore.gotoState(2);
                            }
                            else {
                                console.log('fail');
                                this.showFail = true;
                            }
                        }
                        this.loading = false;
                        return [3, 5];
                    case 4:
                        error_3 = _a.sent();
                        this.error =
                            'Something went wrong searching for your address! Please check your address details and try again.';
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    };
    CheckAddressStore.prototype.mapNbnSqResponseData = function (response) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, locationId, serviceClass, serviceClassDescription, newDevelopmentsChargeApplies, newDevelopmentsCharge, activeService, maximumDownloadSpeed, maximumUploadSpeed, nextState;
            return __generator(this, function (_b) {
                _a = response.nbn, locationId = _a.locationId, serviceClass = _a.serviceClass, serviceClassDescription = _a.serviceClassDescription, newDevelopmentsChargeApplies = _a.newDevelopmentsChargeApplies, newDevelopmentsCharge = _a.newDevelopmentsCharge, activeService = _a.activeService, maximumDownloadSpeed = _a.maximumDownloadSpeed, maximumUploadSpeed = _a.maximumUploadSpeed;
                this.serviceClass = parseInt(serviceClass);
                if ([0, 4, 7, 8, 9, 10, 20, 30].includes(this.serviceClass)) {
                    this.showConfirmation = false;
                    this.showFail = true;
                    this.loading = false;
                    return [2];
                }
                this.contractCodes = [];
                this.nbnLocId = locationId;
                this.serviceClassDescription = serviceClassDescription;
                this.isLineInUse = activeService > 0 ? true : false;
                this.newDevelopmentsChargeApplies = newDevelopmentsChargeApplies;
                this.providerCode = this.providerSelected;
                this.qualificationResponse = response;
                this.maximumDownloadSpeed = maximumDownloadSpeed * 1024;
                this.maximumUploadSpeed = maximumUploadSpeed * 1024;
                this.updateNbnManualAddress();
                if (newDevelopmentsChargeApplies) {
                    this.newDevelopmentsCharge = parseInt(newDevelopmentsCharge.price) * 100;
                }
                this.showFail = false;
                nextState = this.rootStore.config.wholesaleCustomerCode === 'OT' ? 1 : 2;
                this.rootStore.appStore.gotoState(nextState);
                return [2];
            });
        });
    };
    CheckAddressStore.prototype.mapUnitiSqResponseData = function (response) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, locationId, serviceClass, newDevelopmentsChargeApplies, newDevelopmentsCharge, newConnectionChargeApplies, newConnectionCharge, maximumDownloadSpeed, technology, activeService, nextState;
            return __generator(this, function (_b) {
                _a = response.uniti, locationId = _a.locationId, serviceClass = _a.serviceClass, newDevelopmentsChargeApplies = _a.newDevelopmentsChargeApplies, newDevelopmentsCharge = _a.newDevelopmentsCharge, newConnectionChargeApplies = _a.newConnectionChargeApplies, newConnectionCharge = _a.newConnectionCharge, maximumDownloadSpeed = _a.maximumDownloadSpeed, technology = _a.technology, activeService = _a.activeService;
                if (!response.uniti.ipoe) {
                    this.showConfirmation = false;
                    this.showFail = true;
                    this.loading = false;
                    return [2];
                }
                this.serviceClass = parseInt(serviceClass);
                if (![2, 3, 5].includes(this.serviceClass)) {
                    this.showConfirmation = false;
                    this.showFail = true;
                    this.loading = false;
                    return [2];
                }
                if (technology == 'FTTP') {
                    this.flipToFibreService = false;
                }
                else if (technology == 'FIBER') {
                    this.flipToFibreService = true;
                }
                this.contractCodes = [];
                this.nbnLocId = locationId;
                this.newDevelopmentsChargeApplies = newDevelopmentsChargeApplies;
                this.newConnectionChargeApplies = newConnectionChargeApplies;
                this.providerCode = this.providerSelected;
                this.qualificationResponse = response;
                this.maximumDownloadSpeed = maximumDownloadSpeed * 1024;
                this.maximumUploadSpeed = null;
                this.isLineInUse = activeService > 0 ? true : false;
                this.updateUnitiManualAddress();
                if (newDevelopmentsChargeApplies) {
                    this.newDevelopmentsCharge = parseInt(newDevelopmentsCharge.price) * 100;
                }
                if (newConnectionChargeApplies) {
                    this.newConnectionCharge = parseInt(newConnectionCharge.price) * 100;
                }
                this.showFail = false;
                nextState = this.rootStore.config.wholesaleCustomerCode === 'OT' ? 1 : 2;
                this.rootStore.appStore.gotoState(nextState);
                return [2];
            });
        });
    };
    CheckAddressStore.prototype.updateAddress = function (address) {
        this.manualAddress = address;
    };
    CheckAddressStore.prototype.updateNbnManualAddress = function () {
        var locationDetails = this.sqAddressResponse.sqSummary.nbn.locationDetails;
        (this.manualAddress.formattedAddress = this.formattedAddress),
            (this.manualAddress.state = locationDetails.address.stateTerritoryCode),
            (this.manualAddress.streetName = locationDetails.address.roadName),
            (this.manualAddress.streetNumber = locationDetails.address.roadNumber1),
            (this.manualAddress.streetType = locationDetails.address.roadTypeCode),
            (this.manualAddress.suburb = locationDetails.address.localityName),
            (this.manualAddress.postcode = locationDetails.address.postcode);
    };
    CheckAddressStore.prototype.updateUnitiManualAddress = function () {
        var locationDetails = this.sqAddressResponse.sqSummary.uniti
            .locationDetails;
        (this.manualAddress.formattedAddress = this.formattedAddress),
            (this.manualAddress.state = locationDetails.address.stateTerritoryCode),
            (this.manualAddress.streetName = locationDetails.address.roadName),
            (this.manualAddress.streetNumber = locationDetails.address.roadNumber1),
            (this.manualAddress.streetType = locationDetails.address.roadTypeCode),
            (this.manualAddress.suburb = locationDetails.address.localityName),
            (this.manualAddress.postcode = locationDetails.address.postcode);
    };
    CheckAddressStore.prototype.updateValue = function (e) {
        ;
        this.manualAddress[e.currentTarget.name] = e.currentTarget.value;
        console.log(e.currentTarget.value);
    };
    CheckAddressStore.prototype.resetManualAddress = function () {
        this.manualAddress = {};
    };
    CheckAddressStore.prototype.resetCheckForm = function () {
        this.showConfirmation = false;
        this.showFail = false;
        this.loading = false;
        this.rootStore.appStore.gotoStep(0);
    };
    CheckAddressStore.toTitleCase = function (string) {
        return string &&
            string
                .toLowerCase()
                .split(' ')
                .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
                .join(' ');
    };
    CheckAddressStore.sortStreetTypes = function (streetTypes) {
        var sorted = streetTypes
            .sort(CheckAddressStore.sortByNameAscending)
            .map(function (type) { return ({
            abbreviation: type.abbreviation,
            name: CheckAddressStore.toTitleCase(type.name.replace(new RegExp(' _', 'g'), ' ')),
        }); });
        var commonStreetNames = ['Avenue', 'Road', 'Street'];
        var common = sorted.filter(function (type) { return !commonStreetNames.includes(type.name); });
        var standard = sorted.filter(function (type) {
            return commonStreetNames.includes(type.name);
        });
        return __spreadArrays(standard, common);
    };
    CheckAddressStore.sortByNameAscending = function (a, b) { return (a.name === b.name ? 0 : a.name > b.name ? 1 : -1); };
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], CheckAddressStore.prototype, "serviceAddress", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], CheckAddressStore.prototype, "serviceAddress2", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], CheckAddressStore.prototype, "slServiceAddress", null);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], CheckAddressStore.prototype, "manualAddress", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], CheckAddressStore.prototype, "selectedAddress", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], CheckAddressStore.prototype, "streetTypes", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], CheckAddressStore.prototype, "unitTypes", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], CheckAddressStore.prototype, "levelTypes", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], CheckAddressStore.prototype, "states", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], CheckAddressStore.prototype, "slAddresses", void 0);
    __decorate([
        observable,
        __metadata("design:type", Number)
    ], CheckAddressStore.prototype, "serviceClass", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], CheckAddressStore.prototype, "serviceClassDescription", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], CheckAddressStore.prototype, "showConfirmation", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], CheckAddressStore.prototype, "showFail", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], CheckAddressStore.prototype, "notServiceable", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], CheckAddressStore.prototype, "nbnLocId", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], CheckAddressStore.prototype, "formattedAddress", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], CheckAddressStore.prototype, "isLineInUse", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], CheckAddressStore.prototype, "newDevelopmentsChargeApplies", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], CheckAddressStore.prototype, "newConnectionChargeApplies", void 0);
    __decorate([
        observable,
        __metadata("design:type", Number)
    ], CheckAddressStore.prototype, "newConnectionCharge", void 0);
    __decorate([
        observable,
        __metadata("design:type", Number)
    ], CheckAddressStore.prototype, "newDevelopmentsCharge", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], CheckAddressStore.prototype, "contractCodes", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], CheckAddressStore.prototype, "qualificationResponse", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], CheckAddressStore.prototype, "addressesResponse", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], CheckAddressStore.prototype, "locIdSelected", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], CheckAddressStore.prototype, "providerSelected", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], CheckAddressStore.prototype, "maximumDownloadSpeed", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], CheckAddressStore.prototype, "maximumUploadSpeed", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], CheckAddressStore.prototype, "sqAddressResponse", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], CheckAddressStore.prototype, "providerCode", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], CheckAddressStore.prototype, "loading", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], CheckAddressStore.prototype, "error", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], CheckAddressStore.prototype, "flipToFibreService", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], CheckAddressStore.prototype, "upgardeSelected", void 0);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CheckAddressStore.prototype, "getAddressesResponse", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], CheckAddressStore.prototype, "addAddressProviderDetails", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CheckAddressStore.prototype, "addressesSearched", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], CheckAddressStore.prototype, "loadLevelTypes", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], CheckAddressStore.prototype, "loadStreetTypes", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], CheckAddressStore.prototype, "loadStates", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], CheckAddressStore.prototype, "loadUnitTypes", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], CheckAddressStore.prototype, "formatAddress", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], CheckAddressStore.prototype, "manualAddressServiceQualification", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], CheckAddressStore.prototype, "addressSearch", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], CheckAddressStore.prototype, "serviceQualification", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], CheckAddressStore.prototype, "mapNbnSqResponseData", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], CheckAddressStore.prototype, "mapUnitiSqResponseData", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CheckAddressStore.prototype, "updateAddress", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CheckAddressStore.prototype, "updateNbnManualAddress", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CheckAddressStore.prototype, "updateUnitiManualAddress", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CheckAddressStore.prototype, "updateValue", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CheckAddressStore.prototype, "resetManualAddress", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CheckAddressStore.prototype, "resetCheckForm", null);
    return CheckAddressStore;
}());
export { CheckAddressStore };
//# sourceMappingURL=CheckAddressStore.js.map